export const performanceCardIcons = {
  appearances: () => (
    <svg width="80" height="79" viewBox="0 0 80 79" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3278_20681)">
        <rect x="20" y="15" width="40" height="40" rx="10.5" fill="url(#paint0_linear_3278_20681)" fillOpacity="0.15" shapeRendering="crispEdges"/>
        <g clipPath="url(#clip0_3278_20681)">
          <path d="M46.4688 44.8437V42.6562C46.4688 41.4959 46.0078 40.3831 45.1873 39.5626C44.3669 38.7422 43.2541 38.2812 42.0938 38.2812H33.3438C32.1834 38.2812 31.0706 38.7422 30.2502 39.5626C29.4297 40.3831 28.9688 41.4959 28.9688 42.6562V44.8437M53.0313 44.8437V42.6562C53.0305 41.6869 52.7079 40.7452 52.114 39.9791C51.5201 39.2129 50.6886 38.6657 49.75 38.4234M45.375 25.2984C46.3161 25.5394 47.1502 26.0867 47.7459 26.8541C48.3415 27.6214 48.6648 28.5653 48.6648 29.5367C48.6648 30.5081 48.3415 31.4519 47.7459 32.2193C47.1502 32.9867 46.3161 33.534 45.375 33.775M42.0938 29.5312C42.0938 31.9475 40.135 33.9062 37.7188 33.9062C35.3025 33.9062 33.3438 31.9475 33.3438 29.5312C33.3438 27.115 35.3025 25.1562 37.7188 25.1562C40.135 25.1562 42.0938 27.115 42.0938 29.5312Z" stroke="url(#paint1_linear_3278_20681)" strokeWidth="2.16563" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
      <defs>
        <filter id="filter0_dd_3278_20681" x="0.98913" y="0.309782" width="78.0217" height="78.0217" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="0.432065" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_3278_20681"/>
          <feOffset/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3278_20681"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4.32065"/>
          <feGaussianBlur stdDeviation="9.50543"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_3278_20681" result="effect2_dropShadow_3278_20681"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3278_20681" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_3278_20681" x1="40" y1="15" x2="40" y2="55" gradientUnits="userSpaceOnUse">
          <stop stopColor="#9C4FFB"/>
          <stop offset="1" stopColor="#8F3BF4"/>
        </linearGradient>
        <linearGradient id="paint1_linear_3278_20681" x1="41" y1="25.1562" x2="41" y2="44.8437" gradientUnits="userSpaceOnUse">
          <stop stopColor="#9D50FB"/>
          <stop offset="1" stopColor="#8E39F3"/>
        </linearGradient>
        <clipPath id="clip0_3278_20681">
          <rect width="26.25" height="26.25" fill="white" transform="translate(27.875 21.875)"/>
        </clipPath>
      </defs>
    </svg>
  ),

  minutes: () => (
    <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3278_20697)">
        <rect x="19.333" y="15" width="40" height="40" rx="9.8335" fill="url(#paint0_linear_3278_20697)" fillOpacity="0.15" shapeRendering="crispEdges"/>
        <path d="M39.3331 28.854V35L43.4304 37.0486M49.5763 35C49.5763 40.6572 44.9902 45.2432 39.3331 45.2432C33.6759 45.2432 29.0898 40.6572 29.0898 35C29.0898 29.3428 33.6759 24.7568 39.3331 24.7568C44.9902 24.7568 49.5763 29.3428 49.5763 35Z" stroke="url(#paint1_linear_3278_20697)" strokeWidth="2.02816" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <filter id="filter0_dd_3278_20697" x="0.322138" y="0.309782" width="78.0217" height="78.0217" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="0.432065" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_3278_20697"/>
          <feOffset/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3278_20697"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4.32065"/>
          <feGaussianBlur stdDeviation="9.50543"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_3278_20697" result="effect2_dropShadow_3278_20697"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3278_20697" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_3278_20697" x1="39.333" y1="15" x2="39.333" y2="55" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4575F9"/>
          <stop offset="1" stopColor="#4A4DEF"/>
        </linearGradient>
        <linearGradient id="paint1_linear_3278_20697" x1="39.3331" y1="24.7568" x2="39.3331" y2="45.2432" gradientUnits="userSpaceOnUse">
          <stop stopColor="#466DF7"/>
          <stop offset="1" stopColor="#4858F1"/>
        </linearGradient>
      </defs>
    </svg>
  ),

  goals: () => (
    <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3278_20689)">
        <rect x="19.667" y="15" width="40" height="40" rx="9.8335" fill="url(#paint0_linear_3278_20689)" fillOpacity="0.15" shapeRendering="crispEdges"/>
        <path d="M39.6671 45.2432C45.3242 45.2432 49.9103 40.6572 49.9103 35C49.9103 29.3428 45.3242 24.7568 39.6671 24.7568C34.0099 24.7568 29.4238 29.3428 29.4238 35C29.4238 40.6572 34.0099 45.2432 39.6671 45.2432Z" stroke="url(#paint1_linear_3278_20689)" strokeWidth="2.02816" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M39.6671 41.1459C43.0614 41.1459 45.813 38.3943 45.813 35C45.813 31.6057 43.0614 28.854 39.6671 28.854C36.2727 28.854 33.5211 31.6057 33.5211 35C33.5211 38.3943 36.2727 41.1459 39.6671 41.1459Z" stroke="url(#paint2_linear_3278_20689)" strokeWidth="2.02816" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M39.6671 37.0486C40.7985 37.0486 41.7157 36.1314 41.7157 35C41.7157 33.8685 40.7985 32.9513 39.6671 32.9513C38.5356 32.9513 37.6184 33.8685 37.6184 35C37.6184 36.1314 38.5356 37.0486 39.6671 37.0486Z" stroke="url(#paint3_linear_3278_20689)" strokeWidth="2.02816" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <filter id="filter0_dd_3278_20689" x="0.656122" y="0.309782" width="78.0217" height="78.0217" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="0.432065" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_3278_20689"/>
          <feOffset/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3278_20689"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4.32065"/>
          <feGaussianBlur stdDeviation="9.50543"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_3278_20689" result="effect2_dropShadow_3278_20689"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3278_20689" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_3278_20689" x1="39.667" y1="15" x2="39.667" y2="55" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4BBC5B"/>
          <stop offset="1" stopColor="#41A94F"/>
        </linearGradient>
        <linearGradient id="paint1_linear_3278_20689" x1="39.6671" y1="24.7568" x2="39.6671" y2="45.2432" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4CBE5C"/>
          <stop offset="1" stopColor="#40A74E"/>
        </linearGradient>
        <linearGradient id="paint2_linear_3278_20689" x1="39.6671" y1="24.7568" x2="39.6671" y2="45.2432" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4CBE5C"/>
          <stop offset="1" stopColor="#40A74E"/>
        </linearGradient>
        <linearGradient id="paint3_linear_3278_20689" x1="39.6671" y1="24.7568" x2="39.6671" y2="45.2432" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4CBE5C"/>
          <stop offset="1" stopColor="#40A74E"/>
        </linearGradient>
      </defs>
    </svg>
  ),

  assists: () => (
    <svg width="80" height="79" viewBox="0 0 80 79" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3278_20705)">
        <rect x="20" y="15" width="40" height="40" rx="9.8335" fill="url(#paint0_linear_3278_20705)" fillOpacity="0.15" shapeRendering="crispEdges"/>
        <g clipPath="url(#clip0_3278_20705)">
          <path d="M51.2675 28.854L41.5365 38.5851L36.4148 33.4635L28.7324 41.1459M51.2675 28.854H45.1216M51.2675 28.854L51.2675 34.9999" stroke="url(#paint1_linear_3278_20705)" strokeWidth="2.02816" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
      <defs>
        <filter id="filter0_dd_3278_20705" x="0.98913" y="0.309782" width="78.0217" height="78.0217" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="0.432065" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_3278_20705"/>
          <feOffset/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3278_20705"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4.32065"/>
          <feGaussianBlur stdDeviation="9.50543"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_3278_20705" result="effect2_dropShadow_3278_20705"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3278_20705" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_3278_20705" x1="40" y1="15" x2="40" y2="55" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F6B910"/>
          <stop offset="1" stopColor="#F38113"/>
        </linearGradient>
        <linearGradient id="paint1_linear_3278_20705" x1="40" y1="28.854" x2="40" y2="41.1459" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EB960D"/>
          <stop offset="1" stopColor="#D87D09"/>
        </linearGradient>
        <clipPath id="clip0_3278_20705">
          <rect width="24.5837" height="24.5837" fill="white" transform="translate(27.708 22.7081)"/>
        </clipPath>
      </defs>
    </svg>
  ),

  goalsAssists: () => (
    <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3278_20713)">
        <rect x="19.333" y="15" width="40" height="40" rx="9.8335" fill="url(#paint0_linear_3278_20713)" fillOpacity="0.15" shapeRendering="crispEdges"/>
        <g clipPath="url(#clip0_3278_20713)">
          <path d="M35.4492 36.936L34.2098 46.2675L39.3314 43.1946L44.453 46.2675L43.2136 36.9257M46.5016 30.9027C46.5016 34.8627 43.2914 38.073 39.3314 38.073C35.3714 38.073 32.1611 34.8627 32.1611 30.9027C32.1611 26.9427 35.3714 23.7324 39.3314 23.7324C43.2914 23.7324 46.5016 26.9427 46.5016 30.9027Z" stroke="url(#paint1_linear_3278_20713)" strokeWidth="2.02816" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
      <defs>
        <filter id="filter0_dd_3278_20713" x="0.322138" y="0.309782" width="78.0217" height="78.0217" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="0.432065" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_3278_20713"/>
          <feOffset/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3278_20713"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4.32065"/>
          <feGaussianBlur stdDeviation="9.50543"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_3278_20713" result="effect2_dropShadow_3278_20713"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3278_20713" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_3278_20713" x1="39.333" y1="15" x2="39.333" y2="55" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E43C42"/>
          <stop offset="1" stopColor="#DA2144"/>
        </linearGradient>
        <linearGradient id="paint1_linear_3278_20713" x1="39.3314" y1="23.7324" x2="39.3314" y2="46.2675" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E43C42"/>
          <stop offset="1" stopColor="#DA2144"/>
        </linearGradient>
        <clipPath id="clip0_3278_20713">
          <rect width="24.5837" height="24.5837" fill="white" transform="translate(27.041 22.7081)"/>
        </clipPath>
      </defs>
    </svg>
  ),

  teamOfTheWeek: () => (
    <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3278_20725)">
        <rect x="19.667" y="15" width="40" height="40" rx="9.8335" fill="url(#paint0_linear_3278_20725)" fillOpacity="0.15" shapeRendering="crispEdges"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M33.5212 28.8541C32.6726 28.8541 31.9847 29.542 31.9847 30.3905C31.9847 31.2391 32.6726 31.927 33.5212 31.927V28.8541ZM33.5212 33.4635C31.8241 33.4635 30.4482 32.0877 30.4482 30.3905C30.4482 28.6934 31.8241 27.3176 33.5212 27.3176H45.8131C47.5103 27.3176 48.886 28.6934 48.886 30.3905C48.886 32.0877 47.5103 33.4635 45.8131 33.4635V34.3145C45.8131 37.0146 43.4671 39.2427 40.4354 39.5685V41.9142H42.7401V43.4507H36.5942V41.9142H38.8989V39.5685C35.8672 39.2427 33.5212 37.0146 33.5212 34.3145V33.4635ZM39.6671 38.073C42.4358 38.073 44.2766 36.1833 44.2766 34.3145V28.8541H35.0577V34.3145C35.0577 36.1833 36.8985 38.073 39.6671 38.073ZM47.3496 30.3905C47.3496 31.2391 46.6616 31.927 45.8131 31.927V28.8541C46.6616 28.8541 47.3496 29.542 47.3496 30.3905Z" fill="url(#paint1_linear_3278_20725)"/>
      </g>
      <defs>
        <filter id="filter0_dd_3278_20725" x="0.656122" y="0.309782" width="78.0217" height="78.0217" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="0.432065" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_3278_20725"/>
          <feOffset/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3278_20725"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4.32065"/>
          <feGaussianBlur stdDeviation="9.50543"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_3278_20725" result="effect2_dropShadow_3278_20725"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3278_20725" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_3278_20725" x1="39.667" y1="15" x2="39.667" y2="55" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DF7800"/>
          <stop offset="1" stopColor="#B66303"/>
        </linearGradient>
        <linearGradient id="paint1_linear_3278_20725" x1="39.6671" y1="27.3176" x2="39.6671" y2="43.4507" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E17900"/>
          <stop offset="1" stopColor="#B46203"/>
        </linearGradient>
      </defs>
    </svg>
  ),
};

export const performanceCards = [
  {
    key: 'appearances',
    label: 'Appearances',
    icon: performanceCardIcons.appearances,
    getValue: (stats) => stats.matches || stats.appearances || 0,
  },
  {
    key: 'minutes',
    label: 'Minutes',
    icon: performanceCardIcons.minutes,
    getValue: (stats) => stats.minutes_played?.toLocaleString() || 0,
  },
  {
    key: 'goals',
    label: 'Goals',
    icon: performanceCardIcons.goals,
    getValue: (stats) => stats.goals || 0,
  },
  {
    key: 'assists',
    label: 'Assists',
    icon: performanceCardIcons.assists,
    getValue: (stats) => stats.assists || 0,
  },
  {
    key: 'goalsAssists',
    label: 'Goals + Assists',
    icon: performanceCardIcons.goalsAssists,
    getValue: (stats) => stats.goals + stats.assists || 0,
  },
  {
    key: 'teamOfTheWeek',
    label: 'Team of the Week',
    icon: performanceCardIcons.teamOfTheWeek,
    getValue: (stats) => stats.team_of_the_week_appearances || 0,
  },
];
